/* global BACKEND: true */

import { Environment, RecordSource, Store } from 'relay-runtime';
import 'regenerator-runtime/runtime';
import { RelayNetworkLayer, authMiddleware } from 'react-relay-network-modern';

const source = new RecordSource();
const store = new Store(source);

import { getFromLocalStorage } from './utils/browser-storage';

const network = new RelayNetworkLayer([
  authMiddleware({
    token: () => getFromLocalStorage('accessToken'),
    prefix: 'Bearer ',
    header: 'Authorization',
    allowEmptyToken: false,
  }),
  next => req => {
    req.fetchOpts.url = BACKEND + '/api/graphql';
    req.fetchOpts.credentials = 'include';
    return next(req);
  },
]);

const environment = new Environment({
  network,
  store,
});

export default environment;
